export const INITIALIZE_TROVIT = 'INITIALIZE_TROVIT';
export const UPDATE_TROVIT = 'UPDATE_TROVIT';
export const SET_QUERY_TROVIT = 'SET_QUERY_TROVIT';
export const INITIALIZE_CONFIG = 'INITIALIZE_CONFIG';

export const FETCH_INDEX_SEO_REQUEST = 'FETCH_INDEX_SEO_REQUEST';
export const FETCH_INDEX_SEO_START = 'FETCH_INDEX_SEO_START';
export const FETCH_INDEX_SEO_SUCCESS = 'FETCH_INDEX_SEO_SUCCESS';
export const FETCH_INDEX_SEO_FAILED = 'FETCH_INDEX_SEO_FAILED';

export const HIDE_DOWNLOAD_APP_BANNER = 'HIDE_DOWNLOAD_APP_BANNER';
export const HIDE_PERMISSIONS_BANNER = 'HIDE_PERMISSIONS_BANNER';
export const RESET_PERMISSIONS_BANNER = 'RESET_PERMISSIONS_BANNER';

export const WHAT_FIELD_NAME = 'what';
export const WHERE_FIELD_NAME = 'where';

export const SAVE_LAST_SEARCH = 'SAVE_LAST_SEARCH';

export const SHOW_PERMISSIONS_EMAIL_BANNER = 'SHOW_PERMISSIONS_EMAIL_BANNER';
export const HIDE_PERMISSIONS_EMAIL_BANNER = 'HIDE_PERMISSIONS_EMAIL_BANNER';



// WEBPACK FOOTER //
// ./app/Index/constants.js